waitForElement("ProductAmount", function () {
  optionvalues();
});
$(document).on("change", "select", function () {
  optionvalues();
});
$(document).on('click', ".productthumnail .slick-slide", function () {
  IMGSRC = $(this).find('img').attr('src').replace('_compact', '');
  url = "url(" + IMGSRC + ")";
  $('.productthumnailGallery .slick-list .slick-current').css('background-image', url);
});
function optionvalues() {
  let PPATH = window.location.pathname;
  const item = {};
  item["qun"] = $(".pqun").html();
  if ($(".variationoptions").find(".options").length > 0) {
    $(".variationoptions")
      .find(".options")
      .each(function () {
        jsonObj = [];
        item[$(this).find("select").attr("data-index")] = $(this)
          .find("select :selected")
          .val();
        jsonObj.push(item);
      });
  }

  // console.log(item,item.size);
  jQuery.getJSON(PPATH + ".js", function (product) {
    $(".soldvarant").html("");
    $(".pqun").html(1);
    PRODUCT_ID = 0;
    PRODUCT_PRICE = 0;
    COMPARE_PRICE = 0;
    PRODUCT_STATUS = 1;
    SKU = '';
    SELIMG = 0;
    let VARIANTS = product.variants;
    for (i = 0; i < VARIANTS.length; i++) {
      //console.log(VARIANTS);
      switch (Object.keys(item).length) {
        case 1:
          if (!VARIANTS[i].available) {
            $(".soldvarant").html("<span>out of stock</span>");
            PRODUCT_STATUS = 0;
          }
          if (VARIANTS[i]["featured_image"] != null) {
            SELIMG = VARIANTS[i]["featured_image"]['src'];
          }
          SKU = VARIANTS[i]["sku"];
          PRODUCT_ID = VARIANTS[i]["id"];
          PRODUCT_PRICE = VARIANTS[i]["price"];
COMPARE_PRICE = VARIANTS[i]["compare_at_price"];
          break;
        case 2:
          if (VARIANTS[i]["option1"] == item["option1"]) {
            if (!VARIANTS[i].available) {
              $(".soldvarant").html("<span>out of stock</span>");
              PRODUCT_STATUS = 0;
            }
            if (VARIANTS[i]["featured_image"] != null) {
              SELIMG = VARIANTS[i]["featured_image"]['src'];
            }
            SKU = VARIANTS[i]["sku"];
            PRODUCT_ID = VARIANTS[i]["id"];
            PRODUCT_PRICE = VARIANTS[i]["price"];
            //PRODUCT_PRICE = VARIANTS[i]["price"];
COMPARE_PRICE = VARIANTS[i]["compare_at_price"];
          }
          break;
        case 3:
          if (
            VARIANTS[i]["option1"] == item["option1"] &&
            VARIANTS[i]["option2"] == item["option2"]
          ) {
            if (!VARIANTS[i].available) {
              $(".soldvarant").html("<span>out of stock</span>");
              PRODUCT_STATUS = 0;
            }
            if (VARIANTS[i]["featured_image"] != null) {
              SELIMG = VARIANTS[i]["featured_image"]['src'];
            }

            SKU = VARIANTS[i]["sku"];
            PRODUCT_ID = VARIANTS[i]["id"];
            PRODUCT_PRICE = VARIANTS[i]["price"];
            COMPARE_PRICE = VARIANTS[i]["compare_at_price"];
          }
          break;
        case 4:
          if (
            VARIANTS[i]["option1"] == item["option1"] &&
            VARIANTS[i]["option2"] == item["option2"] &&
            VARIANTS[i]["option3"] == item["option3"]
          ) {
            if (!VARIANTS[i].available) {
              $(".soldvarant").html("<span>out of stock</span>");
              PRODUCT_STATUS = 0;
            }
            if (VARIANTS[i]["featured_image"] != null) {
              SELIMG = VARIANTS[i]["featured_image"]['src'];
            }
            SKU = VARIANTS[i]["sku"];
            PRODUCT_ID = VARIANTS[i]["id"];
            PRODUCT_PRICE = VARIANTS[i]["price"];
            COMPARE_PRICE = VARIANTS[i]["compare_at_price"];
          }
          break;
      }
    }
    console.log('Find', SELIMG);

    $('.ProductDetails .sku').html('SKU#: ' + SKU);
   if (COMPARE_PRICE > PRODUCT_PRICE) {
  SHOWPRICE = '<del style="margin-right:8px; color:#999;">$' + FixedV((COMPARE_PRICE / 100), 2) + '</del><span>$' + FixedV((PRODUCT_PRICE / 100), 2) + '</span>';
} else {
  SHOWPRICE = '$' + FixedV((PRODUCT_PRICE / 100), 2);
}
 // $('.SingleProductHeader #ProductAmount span').html(SHOWPRICE);
    

setTimeout(function() {
  $('.shownowbtns .pricechange').html(SHOWPRICE);
  $('#ProductAmount').html(SHOWPRICE);
}, 500);

    //alert(PRODUCT_PRICE/100); 
    $(".addtocartbtndiv .PRODUCT_ADD_CART").attr("data-qun", 1);
    $(".addtocartbtndiv .PRODUCT_ADD_CART").attr("data-pid", PRODUCT_ID);
    $("#productSelect").val(PRODUCT_ID);
    $(".topshopNow #AddToCart").attr("type", "submit");
    $(".topshopNow #AddToCart").removeClass("disable");
    $(".pquantity,.addtocartbtndiv").removeClass("disable");
    $(".pquantity").addClass("active");
    $(".pminus img").attr(
      "src",
      "https://ik.imagekit.io/hb9nqxxf2/minus.svg?updatedAt=1690836481278"
    );
    $(".pplus img").attr(
      "src",
      "https://ik.imagekit.io/hb9nqxxf2/plus.svg?updatedAt=1690836481261"
    );
    if (SELIMG != 0) {
      url = "url(" + SELIMG + ")";
      $('.productthumnailGallery .slick-list .slick-current').css('background-image', url);
    }
    //alert($('.productthumnailGallery .slick-list .slick-current').css('background-image'));
    $(".addtocartbtndiv button").removeAttr("disabled");
    addtocartbutton();
    if (PRODUCT_STATUS == 0) {
      $(".pquantity,.addtocartbtndiv").addClass("disable");
      $(".topshopNow #AddToCart").attr("type", "button");
      $(".topshopNow #AddToCart").attr("disable", "disable");
      $(".topshopNow #AddToCart").addClass("disable");
      $(".pminus img").attr(
        "src",
        "https://ik.imagekit.io/hb9nqxxf2/disable%20minus.svg?updatedAt=1692742448107"
      );
      $(".pplus img").attr(
        "src",
        "https://ik.imagekit.io/hb9nqxxf2/disable%20plus.svg?updatedAt=1692742448057"
      );
      $(".pquantity").removeClass("active");
      $(".addtocartbtndiv button").attr("disabled", "disabled");
      $(".pquantityStatus").find(".pqun").html(0);
    }
  });

}
function addtocartbutton() {

  $(".pquantityStatus").find(".pqun").html(1);

}

jQuery(document).on("click", ".pquantity.active .pplus", function (e) {
  // alert($(".pqun").text());
  e.preventDefault();
  vals = parseInt($(".pqun").text());
  //alert(vals);
  let newval = vals + 1;
  if (newval > 20) {
    newval = vals;
    Title = "Maximum Quantity Reached";
    Msg = "You can select a maximum of 20 items at a time.";
    Notify(Title, Msg);
  }
  $(".addtocartbtndiv .PRODUCT_ADD_CART").attr("data-qun", newval);
  $(this).parents(".pquantityStatus").find(".pqun").html(newval);
});
jQuery(document).on("click", ".pquantity.active .pminus", function (e) {
  e.preventDefault();
  vals = parseInt($(".pqun").text());

  let newval = vals - 1;
  if (newval < 1) {
    newval = 1;
    Title = "Minimum Quantity Required";
    Msg = "You must select a minimum of 1 item at a time.";
    Notify(Title, Msg);
  }
  $(".addtocartbtndiv .PRODUCT_ADD_CART").attr("data-qun", newval);
  $(this).parents(".pquantityStatus").find(".pqun").html(newval);
});

function FixedV(x, n) {
  const v = (typeof x === 'string' ? x : x.toString()).split('.');
  if (n <= 0) return v[0];
  let f = v[1] || '';
  if (f.length > n) return `${v[0]}.${f.substr(0, n)}`;
  while (f.length < n) f += '0';
  return `${v[0]}.${f}`
}